/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Period_Top_HeadlineInputs */

const en_us2_wrapped_period_top_headline = /** @type {(inputs: Wrapped_Period_Top_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your most trained`)
};

const pt_br2_wrapped_period_top_headline = /** @type {(inputs: Wrapped_Period_Top_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seus mais treinados`)
};

const es_419_wrapped_period_top_headline = /** @type {(inputs: Wrapped_Period_Top_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tus más entrenados`)
};

const pt_pt2_wrapped_period_top_headline = /** @type {(inputs: Wrapped_Period_Top_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os teus mais treinados`)
};

const fr_fr2_wrapped_period_top_headline = /** @type {(inputs: Wrapped_Period_Top_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tes plus travaillés`)
};

const de_de2_wrapped_period_top_headline = /** @type {(inputs: Wrapped_Period_Top_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Top-Übungen`)
};

const it_it2_wrapped_period_top_headline = /** @type {(inputs: Wrapped_Period_Top_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I tuoi più allenati`)
};

/**
* | output |
* | --- |
* | "Your most trained" |
*
* @param {Wrapped_Period_Top_HeadlineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_top_headline = /** @type {((inputs?: Wrapped_Period_Top_HeadlineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Top_HeadlineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_top_headline(inputs)
	if (locale === "es-419") return es_419_wrapped_period_top_headline(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_top_headline(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_top_headline(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_top_headline(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_top_headline(inputs)
	return en_us2_wrapped_period_top_headline(inputs)
});
export { wrapped_period_top_headline as "wrapped-period.top_headline" }